export const styles = {
  footer: {
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "flex-end",
  },
};
